import axios from "axios";
import moment from "moment";
import SeatMappingComponent from "../seatMapping";
import { RequestParamsMaker } from "@/components/seatMapping/scripts/make_request_params";
import CognitoController from "@/common/scripts/cognito_controller";
import { SeatSensorData } from "@/types/types";

/**
 * 最新のセンサーデータ取得
 * @param self
 */
export async function getLatestData(self: SeatMappingComponent) {
  try {
    await CognitoController.refreshToken();
    const userID = self.mstSeatMapping.user_id;
    const deviceID = self.mstSeatMapping.device_id;
    const reqParams = await RequestParamsMaker.makeGetSeatDataParams(userID, deviceID, self.authStore);
    const response = await axios(reqParams);
    if (!response.data.res.seat_sensor_data) {
      return null;
    }

    self.latestSensorData = response.data.res.seat_sensor_data[0];
    self.latestDataDate = makeTimeData(self.latestSensorData, self.timeZone);
    return response.data.res.seat_sensor_data[0];
  } catch (err) {
    console.log(err);
    // 取得に失敗したら初回のみ定期取得を中止
    self.isError = true;
  }
}

/**
 * タイムゾーン設定に合わせて生データの時刻を修正
 * @param sensorData
 * @param timeZone
 */
function makeTimeData(
  sensorData: SeatSensorData,
  timeZone: string,
) {
  if (sensorData) {
    sensorData.time_stamp =
      moment(sensorData.time_stamp)
        .utcOffset(timeZone)
        .format("YYYY-MM-DD HH:mm:ss");
    return sensorData.time_stamp;
  }
  return "未取得";
}
